export const SUPPLY_AGENT_FORCE_OPEN_KEY = 'supplyAgent.forceOpen';
export const SUPPLY_AGENT_OPEN_EVENT = 'supply-agent-open';
export const SUPPLY_AGENT_RULES_CHANGED_EVENT = 'supply-agent-rules-changed';

export function requestSupplyAgentOpen(persistForNextMount = false): void {
  if (persistForNextMount) {
    try {
      sessionStorage.setItem(SUPPLY_AGENT_FORCE_OPEN_KEY, '1');
    } catch {
      /* ignore */
    }
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(SUPPLY_AGENT_OPEN_EVENT));
  }
}

export function notifySupplyAgentRulesChanged(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(SUPPLY_AGENT_RULES_CHANGED_EVENT));
  }
}

export function consumeSupplyAgentForceOpen(): boolean {
  try {
    if (sessionStorage.getItem(SUPPLY_AGENT_FORCE_OPEN_KEY) === '1') {
      sessionStorage.removeItem(SUPPLY_AGENT_FORCE_OPEN_KEY);
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}
